<template>
  <div
    class="chat-layout-root"
    :data-theme="chatColorTheme">
    <AppHeader />
    <main class="chat-layout-root__main">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { TRACKING_EVENTS } from '~/constants/trackingEvents'
import {
  chatColorThemePreference,
  ChatColorThemePreference,
} from '~/utils/ChatColorThemePreference'

const { track } = useTracking()

const chatColorTheme = chatColorThemePreference.activeTheme

useHead({
  script: [
    {
      key: 'chat-color-theme-bootstrap',
      innerHTML: ChatColorThemePreference.buildBootstrapScript(),
      tagPosition: 'head',
    },
  ],
})

onMounted((): void => {
  const initResult = chatColorThemePreference.initOnClient()
  if (initResult?.isFirstClientInit) {
    track(TRACKING_EVENTS.CHAT_THEME_RESOLVED, {
      theme: initResult.theme,
      from: initResult.source,
    })
  }
})

onUnmounted((): void => {
  chatColorThemePreference.clearFromDom()
})
</script>

<style scoped>
.chat-layout-root {
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--bg-base);
}

.chat-layout-root__main {
  padding-top: var(--header-height);
  flex: 1;
  height: 0; /* trick flex : permet à l'enfant de faire height:100% */
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
